<template>
  <div>
    <div class="roll_text_box">
      <transition name="slide">
        <p class="roll_text" :key="text.id">
          <span @click="clickMethod(text.val.id)">
            {{text.val.title}}
          </span>
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RollNotice',
    data () {
      return {
        number: 0
      }
    },
    props:{
      textArr: {//需要播放的数组
        type: Array,
        required: true,
        default: []
      },
      timeout: {//滚动时间，默认1.5秒
        type: Number,
        required: false,
        default: 1500
      },
    },
    computed: {
      text () {
        return {
          id: this.number,
          val: this.textArr[this.number]
        }
      }
    },
    mounted () {
      this.startMove()
    },
    methods: {
      startMove () {
        // eslint-disable-next-line
        let timer = setTimeout(() => {
          if (this.number === this.textArr.length) {
            this.number = 0;
          } else {
            this.number += 1;
          }
          this.startMove();
        }, this.timeout); // 滚动不需要停顿则将2000改成动画持续时间
      },
      clickMethod(id){
        this.$emit('fatherMethod', id);
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .roll_text_box {
    width: 100%;
    height: 40px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    text-align: left;
  }
  .roll_text {
    width: 100%;
    position: absolute;
    bottom: 0;
    cursor: pointer;
  }
  .roll_text_box .slide-enter-active, .slide-leave-active {
    transition: all 0.5s linear;
  }
  .roll_text_box .slide-enter{
    transform: translateY(20px) scale(1);
    opacity: 1;
  }
  .roll_text_box .slide-leave-to {
    transform: translateY(-20px) scale(0.8);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/router/rollNotice/rollNotice.vue